"use client"

import { useEffect, useRef, useState } from "react"
import Icon from "./Icon"

function BankCombobox({
  value,
  onChange,
  banksCatalog = [],
  placeholder = "Select bank or type",
  onSelectBank
}) {
  const [open, setOpen] = useState(false)
  const containerRef = useRef(null)

  const normalized = (s) => (String(s || "").toLowerCase())
  const hasCatalog = Array.isArray(banksCatalog) && banksCatalog.length > 0
  const query = normalized(value)
  const filtered = hasCatalog
    ? (query ? banksCatalog.filter(b => normalized(b.name).includes(query)) : banksCatalog)
    : []
  const displayed = filtered.length > 0 ? filtered : (hasCatalog ? banksCatalog : [])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleSelect = (bank) => {
    const name = bank?.name || ""
    onChange?.(name)
    onSelectBank?.(bank || null)
    setOpen(false)
  }

  return (
    <div className="relative" ref={containerRef}>
      <div className="flex items-stretch gap-1">
        <input
          type="text"
          value={value}
          onChange={(e) => { onChange?.(e.target.value); setOpen(true) }}
          onFocus={() => setOpen(true)}
          placeholder={placeholder}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
        />
        <button
          type="button"
          aria-label="Toggle bank list"
          onClick={() => setOpen((v) => !v)}
          className="px-2 border border-gray-300 rounded-lg hover:bg-gray-50"
        >
          <Icon name="chevron-down" size="1rem" />
        </button>
      </div>

      {open && hasCatalog && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-56 overflow-auto">
          {displayed.map((b) => (
            <button
              type="button"
              key={b.name}
              onClick={() => handleSelect(b)}
              className="w-full text-left px-3 py-2 hover:bg-gray-50"
            >
              {b.name}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default BankCombobox


